import * as THREE from 'three'
import Project from './Project'
import gsap from 'gsap'

export default class KIInselSection{
    constructor(_options)
    {
        // Options
        this.time = _options.time
        this.resources = _options.resources
        this.camera = _options.camera
        this.passes = _options.passes
        this.objects = _options.objects
        this.areas = _options.areas
        this.zones = _options.zones
        this.tiles = _options.tiles
        this.debug = _options.debug
        this.x = _options.x
        this.y = _options.y

        // Debug
        if(this.debug)
        {
            this.debugFolder = this.debug.addFolder('projects')
            this.debugFolder.open()
        }

        // Set up
        this.items = []

        this.interDistance = 24
        this.positionRandomess = 5
        this.projectHalfWidth = 9

        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false
        this.container.updateMatrix()

        this.setGeometries()
        this.setMeshes()
        this.setList()
        this.setZone()
        this.setRoads();

        // Add all project from the list
        for(const _options of this.list)
        {
            this.add(_options)
        }
    }
    setGeometries()
    {
        this.geometries = {}
        this.geometries.floor = new THREE.PlaneGeometry(16, 8)
    }

    setMeshes()
    {
        this.meshes = {}

        // this.meshes.boardStructure = this.objects.getConvertedMesh(this.resources.items.projectsBoardStructure.scene.children, { floorShadowTexture: this.resources.items.projectsBoardStructureFloorShadowTexture })
        this.resources.items.areaOpenTexture.magFilter = THREE.NearestFilter
        this.resources.items.areaOpenTexture.minFilter = THREE.LinearFilter
        this.meshes.boardPlane = this.resources.items.projectsBoardPlane.scene.children[0]
        this.meshes.areaLabel = new THREE.Mesh(new THREE.PlaneGeometry(2, 0.5), new THREE.MeshBasicMaterial({ transparent: true, depthWrite: false, color: 0xffffff, alphaMap: this.resources.items.areaOpenTexture }))
        this.meshes.areaLabel.matrixAutoUpdate = false
    }

    setList()
    {
        // Zentrale Basisposition der KI-Insel
        const baseX = 45
        const baseY = 15

        this.list = [
            {
                name: 'AI_Isle',
                x: baseX,
                y: baseY,
                cameraAngle: 'projects',
                useTiles: true,
                interactionTypes: [],
                imageSources:
                    [
                        './models/projects/threejsJourney/slideA.webp',
                        './models/projects/threejsJourney/slideB.webp',
                        './models/projects/threejsJourney/slideC.webp'
                    ],
                floorTexture: this.resources.items.projectsThreejsJourneyFloorTexture,
                link:
                    {
                        href: 'https://www.tu-darmstadt.de/kompaki/wissenssammlung/wissensnugget_2/detailseiten_2/standardseite_184.de.jsp',
                        x: baseX - 47,
                        y: baseY - 1,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    [
                        {type: 'ki-insel', x: 9, y: -6, mass:0  }
                    ]
            },
            {
                name: 'Intro',
                x: baseX + 4,
                y: baseY + 23,
                cameraAngle: 'projects',
                useTiles: true,
                interactionTypes: ['showTexture'],
                floorTexture: this.resources.items.projectsThreejsJourneyFloorTexture,
                link:
                    {
                        href: 'https://www.tu-darmstadt.de/kompaki/wissenssammlung/wissensnugget_2/detailseiten_2/standardseite_184.de.jsp',
                        x: baseX - 51,
                        y: baseY - 24,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },

            },
            {
                name: 'Drawer',
                x: baseX + 33,
                y: baseY + 17,
                cameraAngle: 'projects',
                useTiles: true,
                interactionTypes: ['showVideo'],
                imageSources:
                    [
                        './models/projects/luni/slideA.webp',
                        './models/projects/luni/slideB.webp',
                        './models/projects/luni/slideC.webp'
                    ],
                floorTexture: this.resources.items.projectsLuniFloorTexture,
                link:
                    {
                        href: 'https://www.tu-darmstadt.de/kompaki/wissenssammlung/wissensnugget_2/detailseiten_2/wissensnugget_5.de.jsp',
                        x: - 4.8,
                        y: - 3,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    [

                    ]
            },
            {
                name: 'Papagei',
                useTiles: true,
                x: baseX + 15,
                y: baseY + 16,
                interactionTypes: ['showStory'],
                imageSources:
                    [
                        './models/projects/bonhomme10ans/slideA.webp',
                        './models/projects/bonhomme10ans/slideB.webp',
                        './models/projects/bonhomme10ans/slideC.webp'
                    ],
                floorTexture: this.resources.items.projectsBonhomme10ansFloorTexture,
                floorTextureLeft:this.resources.items.projectsBonhomme10ansFloor1Texture,
                link:
                    {
                        href: 'https://www.tu-darmstadt.de/kompaki/wissenssammlung/wissensnugget_2/detailseiten_2/arbeitsfaehigkeit_uebersicht.de.jsp',
                        x: - 4.8,
                        y: - 2,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    [

                    ]
            },

            {
                name: 'Riskstation',
                useTiles: true,
                x: baseX + 27,
                y: baseY,
                interactionTypes: ['riskStation'],

                imageSources:
                    [
                        './models/projects/chartogne/slideA.jpg',
                        './models/projects/chartogne/slideB.jpg',
                        './models/projects/chartogne/slideC.jpg'
                    ],
                floorTexture: this.resources.items.projectsChartogneFloor1Texture,
                floorTextureLeft:this.resources.items.projectsChartogneFloorTexture,
                link:
                    {
                        href: 'https://www.tu-darmstadt.de/kompaki/wissenssammlung/wissensnugget_2/detailseiten_2/standardseite_185.de.jsp',
                        x: - 4.8,
                        y: - 3.3,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    [

                    ]
            },



        ]
    }

    setZone(x, y, cameraAngle = 'default')
    {
        const totalWidth = this.list.length * (this.interDistance / 2)

        const zone = this.zones.add({
            position: { x: x+2, y: y},
            halfExtents: { x: 12, y: 10},
            data: { cameraAngle: cameraAngle }
        })

        zone.on('in', (_data) =>
        {
            this.camera.angle.set(_data.cameraAngle)
            gsap.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, { x: 0, duration: 2 })
            gsap.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, { y: 0, duration: 2 })
        })

        zone.on('out', () =>
        {
            this.camera.angle.set('default')
            gsap.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, { x: this.passes.horizontalBlurPass.strength, duration: 2 })
            gsap.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, { y: this.passes.verticalBlurPass.strength, duration: 2 })
        })
    }

    add(_options)
    {
        // Falls x oder y im Projekt definiert ist, nimm sie – sonst Standard-Offset
        const x = typeof _options.x === 'number' ? _options.x : this.x + this.items.length * this.interDistance
        const y = typeof _options.y === 'number' ? _options.y : this.y + (Math.random() - 0.5) * this.positionRandomess

        // Create project
        const project = new Project({
            time: this.time,
            resources: this.resources,
            objects: this.objects,
            areas: this.areas,
            geometries: this.geometries,
            meshes: this.meshes,
            debug: this.debugFolder,
            interactionType: _options.interactionType,
            x: x,
            y: y,
            ..._options
        })

        this.container.add(project.container)

        this.setZone(x, y, _options.cameraAngle || 'default')

        // Add tiles
        if(this.items.length >= 1 && (!_options.useTiles))
        {
            const previousProject = this.items[this.items.length - 1]
            const start = new THREE.Vector2(previousProject.x+7 , previousProject.y)
            const end = new THREE.Vector2(project.x - this.projectHalfWidth, project.y)
            const delta = end.clone().sub(start)
            this.tiles.add({
                start: start,
                delta: delta
            })
        }

        // Save
        this.items.push(project)
    }

    setRoads() {
        this.tiles.add(
            {
            start: new THREE.Vector2(13, 12),
            delta: new THREE.Vector2(24, 4)
            },
        )
        this.tiles.add(
            {
            start: new THREE.Vector2(36, 16),
            delta: new THREE.Vector2(32, 0)
            },
        )
    }
}